__turbopack_context__.v({
  "arrow": "GlitchButton-module__sPGskG__arrow",
  "bg": "GlitchButton-module__sPGskG__bg",
  "root": "GlitchButton-module__sPGskG__root",
});
